'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { trackTimeOnTaskPath } from '@/lib/time-on-task-v2/tracker'

interface TrackTimeOnTaskProps {
  enabled: boolean
  studentId: number | null
}

interface TrackTimeOnTaskPathProps extends TrackTimeOnTaskProps {
  pathname: string | null
  onTrackPath?: typeof trackTimeOnTaskPath
}

export function TrackTimeOnTask({ enabled, studentId }: TrackTimeOnTaskProps) {
  return (
    <TrackTimeOnTaskPath
      enabled={enabled}
      pathname={usePathname()}
      studentId={studentId}
    />
  )
}

export function TrackTimeOnTaskPath({
  enabled,
  pathname,
  studentId,
  onTrackPath = trackTimeOnTaskPath,
}: TrackTimeOnTaskPathProps) {
  useEffect(() => {
    if (!enabled) return
    if (typeof studentId !== 'number') return

    void onTrackPath({
      path: pathname,
      studentId,
    })
  }, [enabled, onTrackPath, pathname, studentId])

  return null
}
